module.exports = __webpack_public_path__ + "media/driving_style_en_ipad_new.fa57577f.mp4";